import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import TempAccount from "../../components/pages/Manage/TempAccount/TempAccount/TempAccount";
import TempAccountHistory from "../../components/pages/Manage/TempAccount/TempAccountHistory/TempAccountHistory";
import TempAccountTab, {
  tempAccountTabState,
} from "../../components/pages/Manage/TempAccount/TempAccountTab";
import Flex from "../../components/DefaultStyles/Flex";
import ConfirmBtn from "../../components/Button/ConfirmBtn";
import PartyMailModal from "../../components/pages/Party/PartyDetail/PartyDetailShareInfo/PartyMailModal";
import { Input } from "../../components/Input/Input";
import AllMailView from "../../components/pages/Manage/TempAccount/AllMailView";

export default function ManageTempAccount() {
  const tempAccountTab = useRecoilValue(tempAccountTabState);

  return (
    <>
      <PageTitle title="임시 계정 관리" />

      <AllMailView />

      <TempAccountTab />

      {tempAccountTab === 0 ? (
        // 임시 계정 발급
        <TempAccount />
      ) : (
        // 임시 계정 발급 내역
        <TempAccountHistory />
      )}
    </>
  );
}
